import { Delete } from '@mui/icons-material'
import { FC } from 'react'
import { IconButton } from 'ui'

import styles from './BankDetailsPage.module.scss'

type BankDetailsCardProps = {
  id: number
  bankName: string
  bik: string
  correspondentAccount: string
  currentAccount: string
  onDelete: (id: number) => void
}

export const BankDetailsCard: FC<BankDetailsCardProps> = ({
  id,
  bankName,
  bik,
  correspondentAccount,
  currentAccount,
  onDelete,
}) => (
  <div
    className={styles.bankDetails__card}
    data-testid={`bank-details-card-${id}`}
  >
    <div className={styles.bankDetails__cardHeader}>
      <span className={styles.bankDetails__cardBankName}>{bankName}</span>
      <IconButton
        onClick={() => onDelete(id)}
        data-testid={`bank-details-delete-${id}`}
      >
        <Delete color='error' />
      </IconButton>
    </div>
    <div className={styles.bankDetails__cardRow}>
      <span className={styles.bankDetails__cardLabel}>БИК</span>
      <span className={styles.bankDetails__cardValue}>{bik}</span>
    </div>
    <div className={styles.bankDetails__cardRow}>
      <span className={styles.bankDetails__cardLabel}>
        Корреспондентский счёт
      </span>
      <span className={styles.bankDetails__cardValue}>
        {correspondentAccount}
      </span>
    </div>
    <div className={styles.bankDetails__cardRow}>
      <span className={styles.bankDetails__cardLabel}>Расчётный счёт</span>
      <span className={styles.bankDetails__cardValue}>{currentAccount}</span>
    </div>
  </div>
)
